/* istanbul ignore file */
import React from 'react';
import ContactsBreadcrumbs from 'domain/sales/contact/shared/ContactsBreadcrumbs';
import { SingleBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import { useShowContext } from 'framework/show';
import { useContactId, useContactUrl } from 'domain/sales/contact/contactRouting';

const SingleContactsBreadcrumbs = ({ children = null }: { children?: React.ReactNode }) => {
  const { data } = useShowContext();
  const id = useContactId();
  const { getSingleEntityUrl } = useContactUrl();

  return (
    <ContactsBreadcrumbs>
      <SingleBreadcrumbItem entity={data.getValueBySource('fullName')} link={getSingleEntityUrl(id)} />
      {children}
    </ContactsBreadcrumbs>
  );
};

export default SingleContactsBreadcrumbs;
